import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { Solution5RoutingModule } from './solution5-routing.module';
import { Solution5Component } from './solution5.component';
//import { InformationComponent } from './main.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { SolutionPageModule } from 'src/app/shared/components/solution-page/solution-page.module';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSnackBarModule,
    Solution5RoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SolutionPageModule,
  ],
  declarations: [
    Solution5Component,
    //  InformationComponent
  ],
  entryComponents: [
    //InformationComponent
  ]
})
export class Solution5Module {
}
